(function (angular, app) {
   "use strict";

   app.modules.outing = {
      name: "app.Outing"
      , constants: {
         defaultPoints: {
            tripleBogey: -3
            , doubleBogey: -2
            , bogey: -1
            , par: 0
            , birdie: 2
            , eagle: 5
            , doubleEagle: 8
            , fourUnder: 10
            , pointBase: 0
         }
         , defaultBestBalls: {
            hole1: 1
            , hole2: 1
            , hole3: 1
            , hole4: 1
            , hole5: 1
            , hole6: 1
            , hole7: 1
            , hole8: 1
            , hole9: 1
            , hole10: 1
            , hole11: 1
            , hole12: 1
            , hole13: 1
            , hole14: 1
            , hole15: 1
            , hole16: 1
            , hole17: 1
            , hole18: 1
         }
      }
      , controllers: {
         teetime : "ggTeeTimeController"
      }
      , decorators: {
      }
      , directives: {
         playerpicker: "ggPlayerPickerDirective"
      }
      , filters: {
      }
      , services: {
         outings: "ggOutingService"
      }
      , types: {
         outingClassType: [
            {
               name: "Public"
               , value: 1
            }
            , {
               name: "PublicInvitationOnly"
            , value: 2
            }
            , {
               name: "Private"
            , value: 3
            }
            , {
               name: "PrivateInvitationOnly"
               , value: 4
            }
         ]
         , handicapTypes: [
         { name: "Official" }, { name: "Trend" }, { name: "Group" }
         ]
         , outingStatusType: [
            {
               name: "Offline"
               , value: 1
            }
            , {
               name: "Active"
            , value: 2
            }
            , {
               name: "Archived"
            , value: 3
            }
         ]
         , gameType: [
            {
               name: "Individual"
               , value:1
               , display: "Individual"
            }
            , {
               name: "Team"
               , value: 2
               , display: "Team"
            }
         ]
         , holeType: [
            {
               name: "EighteenHoles"
               , value: 1
               , display: "18 Holes"
            }
            , {
               name: "NineHoles"
               , value: 2
               , display: "9 Holes"
            }
         ]
         , scoringType: [
            {
               name: "Stroke"
               , value: 1
               , display: "Stroke Play"
               , gameType: "Both"
            }
            , {
               name: "BestBall"
               , value: 2
               , display: "Best Ball"
               , gameType: "Team"
            }
            , {
               name: "Scramble"
               , value: 4
               , display: "Scramble"
               , gameType: "Team"
            }
            , {
               name: "AlternateShot"
               , value: 5
               , display: "Alternate Shot"
               , gameType: "Team"
            }
         ]
         , pointType: [
            {
               name: "None"
               , value: null
               , display: "No Point System"
            }
            , {
               name: "Stableford"
               , value: 1
               , display: "Stableford"
            }
            , {
               name: "Quota"
               , value: 2
               , display: "Quota"
            }
         ]
         , alpha: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O", "Q", "R", "S", "T", "W", "X", "Y"]
      }
      , routes: {
         setup: {
            path: "/outing/setup"
            , controller: "gg_OutingSetupController"
            , controllerAs: "ggOutingSetupCtrl"
            , templateUrl: "app/outing/controllers/outingsetup.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , detail: {
            path: "/outing/detail"
            , controller: "gg_OutingDetailController"
            , controllerAs: "ggOutingDetailCtrl"
            , templateUrl: "app/outing/controllers/outingdetail.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , leaderboard: {
            path: "/outing/lb"
            , controller: "gg_OutingLeaderboardController"
            , controllerAs: "ggOutingLeaderboardCtrl"
            , templateUrl: "app/outing/controllers/outingleaderboard.html"
            , features: {
               showHeading: true
            } // Anyone can view
         }
      }
      , templates: {
         playerModal: {
            templateId: "app/outing/controllers/player-modal.html"
         }
         , shareModal: {
            templateId: "app/outing/controllers/share-modal.html"
         }
         , teeModal: {
            templateId: "app/outing/controllers/outingdetail-tee.html"
         }
      }

   };

   angular.module(app.modules.outing.name, []);

}(angular, app));
